import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  all: unset;\n  position: absolute;\n  top: 18px;\n  right: 20px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { styled } from "@mui/material";
import Link from "next/link";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { useRouter } from "next/router";
import Icon from "../icon/Icon";
import { ArrowLeft, Close, Sizes, SolvookLogo_s } from "../icon/IconList";
const MemberPageHeaderContainer = styled("header")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        display: "flex",
        backgroundColor: "transparent",
        position: "relative",
        "&.logo": {
            padding: "20px 0",
            alignItems: "center",
            justifyContent: "center",
            a: {
                display: "flex"
            }
        },
        "&.title": {
            borderBottom: "1px solid ".concat(theme.palette.grey[50]),
            padding: "16px 20px",
            height: "56px",
            boxSizing: "border-box",
            alignItems: "flex-start",
            ".backButton": {
                all: "unset",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "12px"
            },
            p: {
                color: theme.palette.text.primary,
                ...theme.typography.subtitle1
            },
            i: {
                display: "inline"
            }
        }
    };
});
const CloseButtonContainer = styled("button")(_templateObject());
export const MemberPageHeader = (param)=>{
    let { children , showLogo , showBackButton , backButtonLink , pageTitle , onClickBackButton , onClickCloseButton , showCloseButton  } = param;
    const router = useRouter();
    const onClick = ()=>{
        if (showBackButton) {
            if (backButtonLink) {
                router.push(backButtonLink);
                return;
            }
            if (onClickBackButton) {
                onClickBackButton();
                return;
            }
            router.back();
        }
    };
    if (showLogo) return /*#__PURE__*/ _jsxs(MemberPageHeaderContainer, {
        className: "logo",
        children: [
            showLogo && /*#__PURE__*/ _jsx(Link, {
                href: "/",
                onClick: ()=>{
                    mixpanelEvent("Logo Clicked");
                },
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: SolvookLogo_s
                })
            }),
            children
        ]
    });
    return /*#__PURE__*/ _jsxs(MemberPageHeaderContainer, {
        className: "title",
        children: [
            (pageTitle || showBackButton) && /*#__PURE__*/ _jsxs("button", {
                className: "backButton",
                onClick: onClick,
                children: [
                    showBackButton && /*#__PURE__*/ _jsx(Icon, {
                        icon: ArrowLeft,
                        size: Sizes.xmedium
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: pageTitle
                    })
                ]
            }),
            showCloseButton && /*#__PURE__*/ _jsx(CloseButtonContainer, {
                className: "closeButton",
                onClick: onClickCloseButton,
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: Close,
                    size: Sizes.xmedium
                })
            }),
            children
        ]
    });
};
